import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wider transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-navy/5 text-navy',
        gold: 'bg-gold/15 text-gold-dark',
        seeded: 'bg-muted/15 text-muted',
        claimed: 'bg-navy text-cream',
        verified: 'bg-success/15 text-success',
        outline: 'border border-border text-navy',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeVariants>;

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, className }))} {...props} />
  );
}

export { Badge, badgeVariants };
